import cn from 'classnames';
import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/app/redux/rootReducer';
import { SUPPORT_EMAIL } from 'src/shared/consts/links';
import { ButtonSecondary } from 'src/shared/ui/_buttons/ButtonSecondary';
import { Card } from 'src/shared/ui/_layout/Card';
import s from './HeaderProfile.module.scss';

export const HeaderProfile: FC = () => {
	// * Selectors
	const { userData } = useSelector((state: RootState) => state.auth);

	const [open, setOpen] = useState<boolean>(false);

	// * Render
	return (
		<div className={cn(s.container)}>
			<div onClick={() => setOpen(!open)}>{userData ? userData.displayName : 'User'}</div>

			{open && (
				<Card className={s.menu}>
					<ButtonSecondary href={`mailto:${SUPPORT_EMAIL}`}>Customer support</ButtonSecondary>
				</Card>
			)}
		</div>
	);
};
